// extracted by mini-css-extract-plugin
module.exports = {"Telephone":"Telephone_Telephone__y_FQF","AriaDescription":"Telephone_AriaDescription__3fd99"};